import { render, staticRenderFns } from "./TimeFormat.vue?vue&type=template&id=04cc6d34&"
import script from "./TimeFormat.vue?vue&type=script&lang=js&"
export * from "./TimeFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports